import { useEffect, useMemo, useState } from "react";
import { Badge, Button, Modal, Alert } from "antd";
import moment from "moment-timezone";
import dayjsTZ from "../../../utils/dayjs";
import "./DepartmentEmployeeView.scss";
import { useSelector } from "react-redux";
import { getOnlineEmployees } from "../../../utils/getOnlineEmployees";

const DepartmentEmployeeViewModal = ({
  visible,
  setVisible,
  department,
  dataList,
}) => {
  const { users } = useSelector((state) => state.usersList);
  const dateFormat = "DD/MM/YYYY";

  //region ONLINE EMPL
  const onlineEmployees = useMemo(() => {
    return getOnlineEmployees(users.allUsers.Items, dataList);
  }, [dataList, users]);

  return (
    <Modal
      title={`Lista e punonjësve për departamentin ${department?.departmentName}`}
      className="departmentEmployeeViewModal"
      centered
      open={visible}
      onOk={() => setVisible(false)}
      onCancel={() => setVisible(false)}
      footer={[
        <Button
          onClick={() => setVisible(false)}
          className="closeDepartmentEmployeeView"
        >
          Mbyll
        </Button>,
      ]}
    >
      {onlineEmployees?.length > 0 ? (
        <div className="tableContainer">
          <div className="tableHeaders">
            <span>Punonjësit:</span>
            <span>Roli:</span>
            <span>Role të tjera:</span>
            <span>Data e punësimit:</span>
            <span>Dega:</span>
          </div>
          <div className="tableContent">
            {onlineEmployees?.map((el) => (
              <div className="row">
                <span className="item">
                  {el?.isActive ? (
                    <Badge status="success" />
                  ) : (
                    <Badge status="error" />
                  )}
                  {el?.employeeFirstName} {el?.employeeLastName}
                </span>
                <span className="item">{el?.employeeRoleName}</span>
                <span className="item">
                  {el?.employeeOtherPosition?.join(", ") || ""}
                </span>
                <span className="item">
                  {!!el?.employeeHireDate ? (
                    dayjsTZ(el?.employeeHireDate).format(dateFormat)
                  ) : (
                    <span className="item">
                      Nuk ka datë punësimi për këtë punonjës
                    </span>
                  )}
                </span>
                <span className="item">{el?.employeeTeam}</span>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Alert
            message={"Nuk ka asnjë punonjës në këtë departament."}
            type="info"
            showIcon
          />
        </div>
      )}
    </Modal>
  );
};

export default DepartmentEmployeeViewModal;
